import { BaseEntity } from "@memberjunction/core";
import { RegisterClass } from "@memberjunction/global";
import { mjBizAppsCommonOrganizationEntity } from "@mj-biz-apps/common-entities";

/**
 * Client-safe extended OrganizationEntity.
 *
 * Post-BAC (BCSaaS v1.3+), Organization lives in __mj_BizAppsCommon
 * (the BizApps Common BAC layer), not __BCSaaS. The base class therefore
 * extends mjBizAppsCommonOrganizationEntity from @mj-biz-apps/common-entities.
 *
 * Member-lifecycle operations (add/remove member, role assignment, last-owner
 * guard, emails) are now handled by:
 *   - Server-side: BCMembershipService.CreateMembership/RemoveMembership/LeaveMembership
 *   - Entity hooks: OrganizationPersonRoleEntityServer (in @bluecypress/bcsaas-entities-server)
 * Consumers should no longer attempt to write OrganizationContact/RelationshipRole
 * rows directly; use the service so all invariants are enforced.
 */
@RegisterClass(BaseEntity, 'MJ_BizApps_Common: Organizations')
export class OrganizationEntityExtended extends mjBizAppsCommonOrganizationEntity {
}

export function LoadOrganizationEntityExtended(): void {}
